module.exports = __webpack_public_path__ + "img/22.20773b2d.png";